<template>
    <div class="list-rencent-listings-pc standard">
        <div v-show="!showRecentListingNoLocation">
            <!-- sold price avg -->
            <template v-if="soldAvgText">
                <div class="sub-title" v-html="soldAvgText"></div>
            </template>
            <template v-else>
                <listing-nav />
            </template>
            <div class="list_container">
                <listing-table :showLock="showLock" />
            </div>
        </div>
        <div
            class="location_tips_container"
            v-show="showRecentListingNoLocation"
        >
            <img
                class="pic"
                src="//static.chimeroi.com/image/snapshot/v3-img-no-listing@2x.png"
                alt
            />
            <div class="desc">
                {{ $t('md-listing-list.pleaseInputAValid') }}
            </div>
        </div>
        <!-- lock start -->
        <div class="lock-container" v-if="showLock">
            <div class="box">
                <div class="lock-icon">
                    <span
                        class="iconfont icon-circle-lock"
                        @click="showRegisterPop"
                    ></span>
                </div>
                <div class="desc" @click="showRegisterPop">
                    {{ $t('md-listing-list.unlockRecentListings')
                    }}<i class="iconfont icon-chevron_right"></i>
                </div>
            </div>
        </div>
        <!-- lock end -->
    </div>
</template>

<script>
import { mapState } from '@/store/helpers';

import ListingNav from '../nav';
import ListingTable from '../list_table/pc';

import common from '../../../_mixins/recent-listings/common';

export default {
    name: 'rencent-listings-pc',
    mixins: [common],
    components: { 'listing-nav': ListingNav, 'listing-table': ListingTable },
    computed: {

        ...mapState({
            "showRecentListingNoLocation": "showRecentListingNoLocation"
        }),
        
    }
};
</script>

<style lang="scss">
.list-rencent-listings-pc.standard {
    position: relative;
    .sub-title {
        font-family: var(--font-medium);
        margin: 0;
        font-size: 14px;
        letter-spacing: 1px;
        color: #a0a3af;
        text-align: var(--mg-title-align);
        margin-top: -20px;
    }
    .location_tips_container {
        width: 100%;
        padding-top: 80px;
        padding-bottom: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .pic {
            width: 220px;
            height: 130px;
        }
        .desc {
            margin-top: 20px;
            font-size: 16px;
            padding: 0 20px;
            text-align: center;
            color: var(--color-holder);
        }
    }
    .lock-container {
        width: 100%;
        height: 100%;
        min-height: 470px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        position: absolute;
        z-index: var(--level-low);
        top: 0;
        left: 0;
        -webkit-backdrop-filter: blur(4px);
        backdrop-filter: blur(4px);
        background-color: rgba(255, 255, 255, 0.85);
        .lock-icon {
            text-align: center;
            .icon-circle-lock {
                cursor: pointer;
                color: var(--color-theme);
                font-size: 60px;
            }
        }
        .desc {
            cursor: pointer;
            font-size: 16px;
            font-family: var(--font-bold);
            font-weight: 500;
            margin-top: 40px;
            color: var(--color-theme);
        }
    }
}

</style>
